import styled from 'styled-components'

import { FlexContainer } from '@/components'

export const FlexContainerReviews = styled(FlexContainer)`
  width: 100%;
  max-width: 1170px;

  @media (max-width: 1180px) {
    padding: 0 16px;
  }
`

export const ReviewContainer = styled.div`
  margin-top: 80px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex: 1;
  gap: 10%;
  width: 100%;

  @media (max-width: 990px) {
    gap: 40px;
    flex-direction: column;
    padding: 8px;
  }
`
